// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".current-date{margin-left:0.5rem;margin-right:0.5rem;display:none;white-space:nowrap;border-left-width:1px;border-right-width:1px;--tw-border-opacity:1;border-color:rgb(107 114 128 / var(--tw-border-opacity));padding-left:0.5rem;padding-right:0.5rem;font-size:0.875rem;line-height:1}@media (min-width: 1024px){.current-date{display:block}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
